/**
 * Customer requests (F5).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.3, PRD §5.5
 */
import type {
  CreateCustomerRequest,
  CustomerDetail,
  CustomerSummary,
  ListCustomersQuery,
  UpdateCustomerRequest,
} from '@nexus/contracts';

import { api } from '../../../lib/api-client';
import type { PageMeta } from '../../../lib/pagination';

/** A page of customers. */
export interface CustomerPage {
  data: CustomerSummary[];
  meta: PageMeta;
}

export async function listCustomers(query: ListCustomersQuery): Promise<CustomerPage> {
  return api.get<CustomerPage>('/customers', { query });
}

export async function getCustomer(id: string): Promise<CustomerDetail> {
  return api.get<CustomerDetail>(`/customers/${id}`);
}

export async function createCustomer(
  body: CreateCustomerRequest,
): Promise<CustomerDetail> {
  return api.post<CustomerDetail>('/customers', body);
}

export async function updateCustomer(
  id: string,
  body: UpdateCustomerRequest,
): Promise<CustomerDetail> {
  return api.patch<CustomerDetail>(`/customers/${id}`, body);
}
